/* Destination: assets/skyline-header-mega-menu.js */
(() => {
  const desktop = window.matchMedia('(min-width: 990px)');
  const closeDelay = 140;

  const closeOthers = (current) => {
    document.querySelectorAll('[data-skyline-mega][open]').forEach((details) => {
      if (details !== current) details.removeAttribute('open');
    });
  };

  document.querySelectorAll('[data-skyline-mega]').forEach((details) => {
    if (details.dataset.skylineReady === 'true') return;
    details.dataset.skylineReady = 'true';
    let timer;

    const open = () => {
      if (!desktop.matches) return;
      window.clearTimeout(timer);
      closeOthers(details);
      details.setAttribute('open', '');
      details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    };

    const close = () => {
      if (!desktop.matches) return;
      window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        if (details.matches(':hover') || details.contains(document.activeElement)) return;
        details.removeAttribute('open');
        details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      }, closeDelay);
    };

    details.addEventListener('pointerenter', open);
    details.addEventListener('pointerleave', close);
    details.addEventListener('focusin', open);
    details.addEventListener('focusout', close);
    details.addEventListener('toggle', () => {
      details.querySelector('summary')?.setAttribute('aria-expanded', String(details.open));
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-skyline-mega][open]').forEach((details) => {
      details.removeAttribute('open');
      details.querySelector('summary')?.focus();
    });
  });
})();
